<template>

  <div class="all">
    <headercon></headercon>
    <div class="ban">
      <div class="box3"
           v-if="goodsList[0]">
        <h5>{{goodsList[0].title}}</h5>
        <p>{{goodsList[0].date}}</p>
        <span class="s5"
              v-html="goodsList[0].content"></span>
      </div>
    </div>
    <!-- <button class="button"
            @click="go"
            javascript
            :history.back(-1)>
      返回
    </button> -->
    <button class="button"
            onclick="javascript:history.back(-1)">
      返回
    </button>
  </div>
</template>

<script>
import headercon from './header'
import axios from 'axios'
export default {
  components: {
    headercon
  },
  data () {
    return {
      img: require('../assets/componylogo.png'),

      text: '首页',
      text1: '产品与服务',
      text2: '企业动态',
      text3: '资质荣誉',
      text4: '关于我们',
      goodsList: '',
      total: '10'
    }
  },
  created () {
    this.newsId = this.$route.query.newsId
    this.getlist(this.$route.query.newsId)
  },
  methods: {
    back () {
      this.$router.back()
    },
    goHome () {
      this.$router.push({ path: 'home' })
    },
    getlist () {
      const url = this.HOST + '/openApi/newsList'
      const that = this
      let b = this.newsId
      for (let a = 1; a < this.total; a++) {
        console.log(a)
        axios.get(url, { params: { newsId: this.newsId, pageNum: a } })
          .then(function (response) {
            let arr = response.data.rows
            that.total = Math.ceil(response.data.total / 10) + 1
            let arr2 = []
            for (let i = 0; i < arr.length; i++) {
              let arr1 = []
              if (arr[i].id === b) {
                arr1.push(arr[i])
                console.log(arr1[0])
                let str = arr1[0].createTime
                let a = str.substring(0, 10)
                var date = new Date(a)
                var year = date.getYear() + 1900
                var month = date.getMonth() + 1
                var day = date.getDate()
                let date1 = year + '年' + month + '月' + day + '日'
                const object2 = Object.assign({ date: date1 }, arr1[0])
                arr2.push(object2)
              }
              if (arr1.length !== 0) {
                that.goodsList = arr2
              }
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    go () {
      this.$router.push({ path: '/dynamic' })
    }
  }

}
</script>

<style scoped lang="less">
.all {
  background: url("../assets/details.png");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  min-width: 1199px;
  /deep/ .li3 {
    list-style-type: none;
    float: left;
    border-radius: 25px;
    background: #fff;
    width: 100px;
    height: 30px;
    text-decoration: none;
    text-align: center;
    line-height: 30px;
    a {
      color: #757575;
      text-decoration: none;
    }
  }
  .ban {
    width: 75%;
    height: 75%;
    padding-left: 0%;
    margin: 30px auto;
    .box3 {
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      position: relative;
      padding: 0px 10px;
      background: #fff;
      margin: 0 auto;
      h5 {
        text-align: center;
        font-size: 20px;
        background: linear-gradient(to right, #72048d, #2009a5, #5962e2);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      p {
        display: block;
        text-align: center;
        margin-bottom: 10px;
      }

      .s5 {
        /deep/ p {
          background: transparent !important;
        }
        /deep/ span {
          background: transparent !important;
        }
      }
    }
  }
}
@media only screen and (min-width: 1781px) {
  .button {
    position: absolute;
    bottom: 6%;
    margin-left: 80%;
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 10px;
    background: rgb(10, 158, 184);
    border: none;
    color: white;
    font-size: 20px;
  }
}
@media only screen and (min-width: 1601px) and (max-width: 1780px) {
  .button {
    position: absolute;
    bottom: 6%;
    margin-left: 80%;
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 10px;
    background: rgb(10, 158, 184);
    border: none;
    color: white;
    font-size: 20px;
  }
}
@media only screen and (min-width: 1421px) and (max-width: 1600px) {
  .button {
    position: absolute;
    bottom: 4%;
    margin-left: 80%;
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 10px;
    background: rgb(10, 158, 184);
    border: none;
    color: white;
    font-size: 20px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1420px) {
  .button {
    position: absolute;
    bottom: 4%;
    margin-left: 80%;
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 10px;
    background: rgb(10, 158, 184);
    border: none;
    color: white;
    font-size: 20px;
  }
}
@media only screen and (max-width: 1200px) {
  .button {
    position: absolute;
    bottom: 4%;
    margin-left: 950px;
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 10px;
    background: rgb(10, 158, 184);
    border: none;
    color: white;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newsdetail.vue